import React from "react";
import defaultWorkImg from "../../assets/work.jpg";

const WorkItems = ({ item }) => {
  const imageUrl = item.image && item.image.trim() !== "" ? item.image : defaultWorkImg;

  return (
    <div className="work__card" key={item._id || item.id}>
      <img src={imageUrl} alt={item.title} className="work__img" />
      <h3 className="work__title">{item.title}</h3>
      <a
        href={item.url}
        className="work__button"
        target="_blank"
        rel="noopener noreferrer"
      >
        Demo <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </a>
    </div>
  );
};

export default WorkItems;
